module.exports = "/_next/static/images/nflIcon@3x-83cc20145a2211750b9bdb7b9ebd4869.png";